module.exports = __webpack_public_path__ + "static/media/google_plus_reshare.f41ac95b.svg";